// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3daBv","name":"ConsentHeader_name__3m6Fm","birthday":"ConsentHeader_birthday__LI0IC","skeleton":"ConsentHeader_skeleton__1nbM4"};